import { render } from "./AccountMovement.vue?vue&type=template&id=3ccda968"
import script from "./AccountMovement.vue?vue&type=script&lang=js"
export * from "./AccountMovement.vue?vue&type=script&lang=js"

import "./AccountMovement.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__